import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsCustomersListRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('customer');
  }
}

export default instrumentRoutePerformance(SettingsCustomersListRoute);
